import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../utils/cn';
import { useToast } from './useToast';
const SEVERITY_COLOR = {
    info: 'var(--sec-info)',
    success: 'var(--sec-success)',
    warning: 'var(--sec-warning)',
    error: 'var(--sec-danger)',
};
const regionStyle = {
    position: 'fixed',
    insetBlockEnd: 16,
    insetInlineEnd: 16,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    zIndex: 2000,
    maxWidth: 'min(380px, 92vw)',
};
/**
 * Rendert die aktiven Toasts aus dem `ToastProvider` in einer Live-Region
 * (`aria-live="polite"`), damit Screenreader Statusmeldungen erhalten.
 */
export function Toaster({ dismissLabel = 'Schließen', className }) {
    const { toasts, dismiss, pause, resume } = useToast();
    if (toasts.length === 0)
        return null;
    return (_jsx("div", { className: cn('sec-toaster', className), style: regionStyle, role: "status", "aria-live": "polite", onMouseEnter: pause, onMouseLeave: resume, onFocus: pause, onBlur: (e) => {
            // Erst fortsetzen, wenn der Fokus den Toaster wirklich verlaesst.
            if (!e.currentTarget.contains(e.relatedTarget))
                resume();
        }, children: toasts.map((toast) => (_jsxs("div", { className: "sec-card", style: {
                display: 'flex',
                alignItems: 'flex-start',
                gap: 10,
                padding: '10px 12px',
                borderInlineStart: `4px solid ${SEVERITY_COLOR[toast.severity]}`,
            }, children: [_jsx("span", { style: { flex: 1 }, children: toast.message }), _jsx("button", { type: "button", className: "sec-btn sec-btn--ghost", "aria-label": dismissLabel, onClick: () => dismiss(toast.id), children: "\u2715" })] }, toast.id))) }));
}
